import request from '@/utils/request'
import locale from './../lang/i18n'
import { adminPath, deleteMedia, paged, updateSettings, uploadMedia } from './adminV1'

function publicLocale () {
  return locale.locale === 'en-US' ? 'en' : 'zh-cn'
}

function payload (data) {
  return {
    title: data.title || data.docTitle,
    description: data.description || data.docDesc,
    fileName: data.fileName,
    downloadUrl: data.downloadUrl || data.downloadPath,
    publishDate: data.publishDate || data.uploadTime,
    slug: data.slug,
    translationGroup: data.translationGroup,
    seoTitle: data.seoTitle,
    metaDescription: data.metaDescription,
    coverAlt: data.coverAlt || data.docTitle,
    publishStatus: data.publishStatus || 'PUBLISHED'
  }
}

export function settingTopBackground (file) {
  return uploadMedia(file, 'image')
    .then(media => updateSettings({ resourceTopImage: media.url }))
    .then(data => ({ code: 0, data }))
}

export function getTopBackground () {
  return request({ url: adminPath('/settings'), method: 'get' })
    .then(data => ({ code: 0, data: { value: data.resourceTopImage || '' } }))
}

export function getWebTopBackground () {
  return request({ url: `/api/public/v1/${publicLocale()}/media/TECH_DOC_TOP_IMG`, method: 'get' })
    .then(data => ({ code: 0, data }))
}

export function getTechDocList (data) {
  const query = data || {}
  return request({
    url: adminPath('/resources/page'),
    method: 'get',
    params: {
      pageNum: query.pageNum,
      pageSize: query.pageSize,
      searchFileName: String(query.searchFileName || '').trim() || undefined
    }
  }).then(page => ({ code: 0, data: { rows: page.rows, total: page.total } }))
}

export function getTechnicalList (data) {
  const query = data || {}
  return request({ url: `/api/public/v1/${publicLocale()}/resources`, method: 'get' }).then(list => {
    const page = paged(list, query)
    return {
      code: 0,
      data: {
        rows: page.rows.map(item => ({
          ...item,
          id: item.slug,
          docTitle: item.title,
          docDesc: item.description,
          downloadPath: item.downloadUrl
        })),
        total: page.total
      }
    }
  })
}

export function deleteTechnical (id) {
  return request({ url: adminPath(`/resources/${id}`), method: 'delete' })
    .then(() => ({ code: 0 }))
}

export function uploadFile (file) {
  return uploadMedia(file, 'document').then(data => ({ code: 0, data }))
}

export function delFile (url) {
  return deleteMedia(url).then(() => ({ code: 0 }))
}

export function getTechnicalContent (id) {
  return request({ url: adminPath(`/resources/${id}`), method: 'get' })
    .then(data => ({ code: 0, data }))
}

export function addTechnical (data) {
  return request({ url: adminPath('/resources'), method: 'post', data: payload(data) })
    .then(result => ({ code: 0, data: result }))
}

export function updateTechnical (data) {
  return request({ url: adminPath(`/resources/${data.id}`), method: 'put', data: payload(data) })
    .then(result => ({ code: 0, data: result }))
}

export function downloadFile (item) {
  const url = item && typeof item === 'object' ? (item.downloadPath || item.downloadUrl) : item
  return request({ url, method: 'get', responseType: 'blob' })
}

export function downloadResource (id) {
  return request({ url: adminPath(`/resources/${id}`), method: 'get' })
    .then(item => request({ url: item.downloadPath, method: 'get', responseType: 'blob' }))
}
